import * as v from 'valibot';

export const sortOptionSchema = v.object({
  id: v.string(),
  label: v.string(),
  value: v.string(),
});

export const sortingOptionsApiSchema = v.array(sortOptionSchema);

// TODO - update when api will be implemented
export const sortingOptionsSchema = v.optional(sortingOptionsApiSchema);

export type SortOption = v.InferOutput<typeof sortOptionSchema>;
export type SortingOptions = v.InferOutput<typeof sortingOptionsApiSchema>;
